module.exports = __webpack_public_path__ + "973a171add8cd42c5cb0e5b3a4e9a98d.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2019-04-04/whats-new.html
// module id = 1916
// module chunks = 0